import { render, staticRenderFns } from "./carousel-product-cards-cmp.vue?vue&type=template&id=0dbdc167&scoped=true"
import script from "./carousel-product-cards-cmp.vue?vue&type=script&lang=js"
export * from "./carousel-product-cards-cmp.vue?vue&type=script&lang=js"
import style0 from "./carousel-product-cards-cmp.vue?vue&type=style&index=0&id=0dbdc167&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dbdc167",
  null
  
)

export default component.exports